import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import AdminPortal from './admin/Portal';
import AdminLogin from './admin/login';
import AdminSignup from './admin/Signup';
import AdminDashboard from './admin/Dashboard';
import AdminForgotPassword from './admin/pages/ForgotPassword'; // Renamed for clarity
import AdminResetPassword from './admin/pages/ResetPassword';
import ManagerLogin from './manager/ManagerLogin';
import ManagerDashboard from './manager/ManagerDashboard';
import Cashouts from './manager/pages/Cashouts';
import CreateTable from './manager/pages/CreateTable';
import ManagePlayers from './manager/pages/ManageUsers';
import ManageTables from './manager/pages/ManageTables';
import RegisterPlayer from './manager/pages/RegisterUser';
import DistributeCredits from './manager/pages/DistributeCredits';
import SetCashoutRate from './manager/pages/SetCashoutRate';
import AdminChangePassword from './admin/pages/ChangePassword';
import ManagerChangePassword from './manager/pages/ChangePassword';
import ManagerForgotPassword from './manager/pages/ForgotPassword'; // Added import
import ManagerResetPassword from './manager/pages/ResetPassword'; // Added import
import GlobalRtpControl from './manager/pages/GlobalRtpControlFixed';
import TimeRTPSchedule from './manager/pages/TimeRTPSchedule';
import VolatilityControl from './manager/pages/VolatilityControl';
import ManagerAccount from './manager/pages/Account';
import RiskControl from './manager/pages/RiskControl';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* LANDING PAGE */}
        <Route path="/" element={<Landing />} />

        {/* ADMIN PORTAL */}
        <Route path="/admin" element={<AdminPortal />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/signup" element={<AdminSignup />} />
        <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
        <Route path="/admin/reset-password" element={<AdminResetPassword />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/change-password" element={<AdminChangePassword />} />

        {/* MANAGER PORTAL */}
        <Route path="/manager/login" element={<ManagerLogin />} />
        <Route path="/manager" element={<ManagerDashboard />}>
          <Route index element={<ManageTables />} />
          <Route path="cashouts" element={<Cashouts />} />
          <Route path="cashout-requests" element={<Cashouts />} />
          <Route path="create-table" element={<CreateTable />} />
          <Route path="manage-players" element={<ManagePlayers />} />
          <Route path="manage-my-users" element={<ManagePlayers />} />
          <Route path="manage-users" element={<ManagePlayers />} />
          <Route path="manage-tables" element={<ManageTables />} />
          <Route path="manage-my-tables" element={<ManageTables />} />
          <Route path="register-player" element={<RegisterPlayer />} />
          <Route path="register-user" element={<RegisterPlayer />} />
          <Route path="distribute-credits" element={<DistributeCredits />} />
          <Route path="set-cashout-rate" element={<SetCashoutRate />} />
          <Route path="global-rtp" element={<GlobalRtpControl />} />
          <Route path="risk-control" element={<RiskControl />} />
          <Route path="time-rtp-schedule" element={<TimeRTPSchedule />} />
          <Route path="volatility-control" element={<VolatilityControl />} />
          <Route path="change-password" element={<ManagerChangePassword />} />
          <Route path="account" element={<ManagerAccount />} />
        </Route>
        <Route path="/manager/forgot-password" element={<ManagerForgotPassword />} /> {/* Added route */}
        <Route path="/manager/reset-password" element={<ManagerResetPassword />} /> {/* Added route */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
